function createHeart() {
  const heart = document.createElement("div");
  heart.classList.add("valentines-heart");

  heart.style.left = `${Math.random() * 100}vw`;
  heart.style.animationDuration = `${Math.random() * 2 + 3}s`;

  heart.textContent = "💗";

  document.body.appendChild(heart);

  setTimeout(() => {
    heart.remove();
  }, 5000);
}

const today = new Date();
const isValentinesEve = today.getMonth() === 1 && today.getDate() === 14;
const reduceMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches;

if (
  document.body.classList.contains("home") &&
  isValentinesEve &&
  !reduceMotion
) {
  setInterval(createHeart, 300);
}
